<template>
    <div class="modal fade" id="licenseActivationModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('license.activate_title') }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label class="form-label">{{ $t('license.key_label') }}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="licenseKey"
                            :placeholder="$t('license.key_placeholder')"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        {{ $t('license.cancel') }}
                    </button>
                    <button type="button" class="btn btn-primary" :disabled="!licenseKey || loading" @click.prevent="activateLicense">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                        {{ $t('license.activate_btn') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import { ref } from 'vue'

const licenseKey = ref('')
const loading = ref(false)

import { useStore } from 'vuex'

const store = useStore()

function activateLicense() {
  loading.value = true
  store.dispatch('license/activateLicense',{license_key: licenseKey.value})
      .then(res => {
        window.toastr.success(res.data?.message || i18n.global.t('license.activated_success'))
        licenseKey.value = ''
        $('#licenseActivationModal').modal('hide')
      })
      .catch()
      .finally(() => loading.value = false)
}

</script>
